import {
    headerTokenKey,
    getToken
} from '../@react-fefmwk/auth/services/token'
import {basename} from '../@react-fefmwk/requests/api'
import {
    currentDomain,
    doCall,
    //sync_doCall,
    getEP
} from '../@react-fefmwk/requests/api'

const current_domain = currentDomain()
const current_protocol = window.location.protocol === 'https:' ? 'https:' : 'http:'
export const serviceUrl = current_domain === "my.anthilia.stage.it"
    ? current_protocol+"//api.anthilia.stage.it/myarea"
    : current_protocol+"//my.anthilia.it/api/myarea"

export const EP = {
    //##AUTHENTICATION
    "login": "/login",
    "logout": "/logout",
    "forgot_password": "/password-forgot",
    "forgot_password_verify": "/password-forgot/verify",
    "reset_password": "/password-reset",
    "is_undermaintenance": "/is_undermaintenance",

    "accept_terms_conditions": "/accept/terms-conditions",

    //#FILES
    "files_viewer":"/files/viewer",

    //##USER
    "users_list": "/users/list",
    "users_get": "/users/get",
    "users_create": "/users/create",
    "users_update": "/users/update",
    "users_delete": "/users/delete",
    "users_fields": "/users/fields",

    "users_dashboard": "/users",
}

export async function files_viewer(relpath,filename = '',force_download = true){
    let callUrl = getEP( 'files_viewer' )

    const _filename = filename ? filename : basename(relpath)
    callUrl += '?path=' + relpath+'&force_download='+force_download+'&filename='+_filename

    return await doCall(callUrl, {
        method: 'GET',
        headers: {
            [headerTokenKey]: getToken()
        }
    },'file',{filename: _filename,force_download: force_download,loader: false})
}
export async function users_dashboard( id_user ) {
    let callUrl = getEP( 'users_dashboard' )
    callUrl += "/"+id_user+"/dashboard"

    return await doCall( callUrl,{
        method: 'POST',
        headers: {
            [headerTokenKey]: getToken(),
        },
        body: JSON.stringify({}),
    },'json.array')
}
export async function login( data ) {
    const callUrl = getEP( 'login' )

    const login = await doCall( callUrl,{
        method: 'POST',
        body: JSON.stringify(data),
        headers: {
            'Content-Type': 'application/json',
            [pkey_name]: pkey
        }
    },'json.object')

    return login
}
export async function login_MFAVerify( data ) {
    const callUrl = getEP( 'login_mfa_verify' )

    const login = await doCall( callUrl,{
        method: 'POST',
        body: JSON.stringify(data),
        headers: {
            'Content-Type': 'application/json',
            [pkey_name]: pkey
        }
    },'json.object')

    const {token = ""} = login

    return token
}
export async function request_password_reset( data ) {
    const callUrl = getEP( 'request_password_reset' )

    return await doCall( callUrl,{
        method: 'POST',
        body: JSON.stringify(data),
        headers: {
            'Content-Type': 'application/json',
            [pkey_name]: pkey
        }
    },'json.object')
}
export async function change_password( data ) {
    const callUrl = getEP( 'change_password' )

    return await doCall( callUrl,{
        method: 'POST',
        body: JSON.stringify(data),
        headers: {
            'Content-Type': 'application/json',
            Authorization: "Bearer " + getToken(),
            [pkey_name]: pkey
        }
    },'json.object')
}
export async function accept_terms_conditions( ) {
    const callUrl = getEP( 'accept_terms_conditions' )

    return await doCall( callUrl,{
        method: 'GET',
        headers: {
            Authorization: "Bearer " + getToken(),
            [pkey_name]: pkey
        }
    },'json.object',{loader:true})
}